import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { checkTokenExpired } from "../../utils/utils";
import PageNotFound from "../../pages/Error/PageNotFound";
import { hasRight } from "../../utils/userTools";
import { routes } from "../../router";
import { useSelector } from "react-redux";
import { call } from "redux-saga/effects";
import { persistor } from "../../store"; 

// Import the hasRight function

const PrivateRoute = ({ element }) => {
  //const user = JSON.parse(localStorage.getItem("user"));
  const user = useSelector(state => state.Login.user);
  const token = checkTokenExpired();
  const location = useLocation();
  const localStorageToken = localStorage.getItem('accessToken');

  // If token is expired or user is not logged in, redirect to login
  if (token.logout || !user || !user.id || !localStorageToken) {
    // Clear local storage and redirect to login
      call([persistor, persistor.purge]);
    return <Navigate to="/login" />;
  }

  // Find the current route configuration based on the path
  const currentPath = location.pathname;

  // Find matching route (exact match or with params like /users/:id)
  const currentRoute = routes.find(route => {
    if (route.path === currentPath) return true;
    
    // Handle routes with params (like /users/123)
    if (route.path && route.path.includes(':')) {
      const routePathSegments = route.path.split('/');
      const currentPathSegments = currentPath.split('/');
      
      if (routePathSegments.length !== currentPathSegments.length) return false;
      
      for (let i = 0; i < routePathSegments.length; i++) {
        if (routePathSegments[i].startsWith(':')) continue;
        if (routePathSegments[i] !== currentPathSegments[i]) return false;
      }
      return true;
    }
    
    return false;
  });

  // If no matching route found, render the element (let 404 route handle it)
  if (!currentRoute) {
    return element;
  }

  // Check if the route has rights configuration
  if (currentRoute.rightName && currentRoute.rights) {
    // Check if user has at least one of the required rights
    const hasRequiredRights = currentRoute.rights.some(right => 
      hasRight(currentRoute.rightName, right, user)
    );

    if (!hasRequiredRights) {
      // User doesn't have the required rights, show 404 page
      return <PageNotFound />;
    }
  }

  // User has the required rights, render the protected component
  return element;
};

export default PrivateRoute;